// @flow
import { get } from 'lodash';
import { resolve, reject } from 'redux-optimist-promise';

import {
  FETCH_PROPOSALS,
  ADD_ACCOMMODATION,
  ADD_TRANSPORT,
  FETCH_SELECTED_PROPOSAL_PAYMENT,
  SAVE_CUSTOMER_PROPOSAL,
  FETCH_PROPOSALS_FROM_EDIT_CRITERIA,
} from 'Store/booking/proposals/constants';
import { START_LOADING, END_LOADING } from 'Store/global-loader/globalLoader.action';

type State = boolean;

const initialState: State = false;

export default function(state?: State = initialState, action: ?Action<*>): State {
  switch (get(action, 'type')) {
    case START_LOADING:
    case ADD_ACCOMMODATION:
    case ADD_TRANSPORT:
    case FETCH_PROPOSALS:
    case FETCH_SELECTED_PROPOSAL_PAYMENT:
    case SAVE_CUSTOMER_PROPOSAL:
    case FETCH_PROPOSALS_FROM_EDIT_CRITERIA:
      return true;

    case END_LOADING:
    case resolve(ADD_ACCOMMODATION):
    case reject(ADD_ACCOMMODATION):
    case resolve(ADD_TRANSPORT):
    case reject(ADD_TRANSPORT):
    case reject(FETCH_PROPOSALS):
    case resolve(FETCH_SELECTED_PROPOSAL_PAYMENT):
    case reject(FETCH_SELECTED_PROPOSAL_PAYMENT):
    case resolve(SAVE_CUSTOMER_PROPOSAL):
    case reject(SAVE_CUSTOMER_PROPOSAL):
    case resolve(FETCH_PROPOSALS_FROM_EDIT_CRITERIA):
    case reject(FETCH_PROPOSALS_FROM_EDIT_CRITERIA):
      return false;

    case resolve(FETCH_PROPOSALS):
      return get(action, 'payload.proposals.errors') ? false : state;

    default:
      return state;
  }
}
